import { serviceMaker } from "..";
import { IActiveInactive, IPagination } from "../../data/AppInterface";
import { TBitValue } from "../../data/AppType";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";
import { paginationParams, toQueryString } from "../../utils/QueryString";

export interface ICreditPlanPayload {
  name: string;
  credit_type: string;
  credits: number;
  visibility_type: string;
  base_price: number;
  cgst: number;
  sgst: number;
  igst: number;
  is_active: TBitValue;
}

export interface ICreditPlanFilter {
  credit_type: string | null;
  visibility_type: string | null;
  is_active: string | null;
}

export const GET_ALL_CREDIT_PLAN = (
  pagination: IPagination,
  search: string,
  filter: ICreditPlanFilter
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_credit_plan.url +
      toQueryString({ ...paginationParams(pagination), search, ...filter }),
    API_ENDPOINTS.get_all_credit_plan.method
  );

export const CREATE_CREDIT_PLAN = (payload: ICreditPlanPayload) =>
  serviceMaker(
    API_ENDPOINTS.create_credit_plan.url,
    API_ENDPOINTS.create_credit_plan.method,
    payload
  );

export const UPDATE_CREDIT_PLAN = (payload: ICreditPlanPayload, id: string) =>
  serviceMaker(
    API_ENDPOINTS.update_credit_plan.url(id),
    API_ENDPOINTS.update_credit_plan.method,
    payload
  );

export const ACTIVE_INACTIVE_CREDIT_PLAN = (id: string, value: IActiveInactive) =>
  serviceMaker(
    API_ENDPOINTS.active_inactive_credit_plan.url(id),
    API_ENDPOINTS.active_inactive_credit_plan.method,
    value
  );

export const DELETE_CREDIT_PLAN = (id: string) =>
  serviceMaker(
    API_ENDPOINTS.delete_credit_plan.url(id),
    API_ENDPOINTS.delete_credit_plan.method
  );
